// import { DIC } from "@/const/dic";
import { validateChinese, validatenum } from "@/util/validate";
// import { formatterTime } from "@/util/util";
const validateName = (rule, value, callback) => {
  if (!validateChinese(value) || value.length > 30 || value.length < 1) {
    callback(new Error("分类名称为1-30位中文"));
  } else {
    callback();
  }
};
const validateNumber = (rule, value, callback) => {
  if (!validatenum(value)) {
    callback(new Error("请输入正确的整数数值"));
  } else {
    callback();
  }
};
export const waterProofTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  size: "mini",
  selection: true,
  menu: true,
  menuBtnTitle: "更多",
  menuType: "menu",
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: "400",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    // orderStatus
    {
      label: "代理商",
      prop: "rootDepartId",
      type: "select",
      search: true,
      hide: true,
    },
    {
      label: "报单编号",
      prop: "number",
      type: "input",
      search: true,
    },
    {
      width: 100,
      label: "订单状态",
      prop: "orderStatus",
      type: "select",
      dicData: [
        {
          label: "待指派",
          value: "WAIT_FOR_ASSIGN",
        },
        {
          label: "待终审",
          value: "TO_BE_THE_FINAL",
        },
        {
          label: "施工中",
          value: "WAIT_INSTALL",
        },
      ],
      search: true,
      solt: true,
    },
    /* {
      width: 50,
      label: "销售部门",
      prop: "region",
      type: "input",
      search: true,
      overHidden: true,
    }, */
    {
      label: "施工地址(区/县)",
      prop: "customAddress",
      type: "input",
      search: true,
      overHidden: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "报单商家名称",
      prop: "shopName",
      type: "input",
      search: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    // 店铺电话
    {
      label: "报单商家电话",
      prop: "shopMobile",
      //overHidden: true,
      search: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateNumber,
        },
      ],
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      // search: true,
      sortable: true,
      overHidden: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "户型",
      prop: "houseType",
      type: "input",
      overHidden: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    /* {
      label: "预估面积",
      prop: "area",
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateNumber,
        },
      ],
    },
    {
      label: "是否下沉式",
      prop: "lowerLevelType",
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    }, */
    {
      label: "是否使用回填宝",
      prop: "backFill",
      type: "input",
      overHidden: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "业主姓名",
      prop: "customName",
      span: 12,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "业主电话",
      prop: "customMobile",
      span: 12,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "付款人姓名",
      prop: "contactName",
      span: 12,
      search: true,
      overHidden: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "付款人号码",
      prop: "contactMobile",
      span: 24,
      type: "input",
      search: true,
      overHidden: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "开始时间",
      prop: "timeStart",
      type: "datetime",
      search: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "结束时间",
      prop: "timeEnd",
      search: true,
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    /* {
      label: "预约人类型",
      prop: "appointmentType",
      type: "input",
      overHidden: true,
    }, */
    {
      label: "涂料使用颜色",
      prop: "paintType",
      type: "input",
      overHidden: true,
    },
    {
      label: "预付款",
      prop: "advanceCharge",
      type: "input",
      overHidden: true,
    },
    {
      label: "付款凭证",
      prop: "picUrl",
      span: 24,
      solt: true,
      formsolt: true,
      overHidden: true,
    },
    {
      label: "回填坑位数量",
      prop: "voucher",
      type: "input",
      overHidden: true,
    },
    {
      label: "装饰公司/商家名称",
      prop: "paymentTarget",
      type: "input",
      overHidden: true,
    },
    {
      label: "业务员",
      prop: "introducer",
      type: "input",
      overHidden: true,
    },
    {
      label: "预计进场时间",
      prop: "entranceTime",
      type: "datetime",
      overHidden: true,
      sortable: true,
      format: "yyyy-MM-dd HH:mm:ss",
    },
    {
      label: "报单日期",
      prop: "declarationDate",
      type: "datetime",
      sortable: true,
      overHidden: true,
      format: "yyyy-MM-dd HH:mm:ss",
    },
    {
      label: "充值扣款商家",
      prop: "recipientPay",
      type: "input",
    },
    /* {
      label: "楼层",
      prop: "floor",
      type: "input",
    },
    {
      label: "收款人",
      prop: "payee",
      type: "input",
    }, */
    /* {
      label: "返利账号",
      prop: "reference",
      type: "input",
    }, */
    /*  // 店铺地址
    {
      label: "店铺地址",
      prop: "shopAddress",
      //overHidden: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    }, */
    {
      label: "备注",
      prop: "remarks",
      type: "textarea",
      span: 24,
      overHidden: true,
      max: 255,
    },
    {
      label: "订单信息",
      prop: "name",
      children: [
        {
          label: "实付金额",
          prop: "payMoney",
        },
        {
          label: "订金",
          prop: "deposit",
        },
        {
          label: "支付时间",
          prop: "payTime",
          type: "datetime",
          valueFormat: "timestamp",
          format: "yyyy-MM-dd HH:mm:ss",
          overHidden: true,
          addVisdiplay: false,
          editVisdiplay: false,
        },
        {
          label: "优惠券",
          prop: "couponName",
        },
        {
          label: "优惠金额",
          prop: "discountAmount",
        },
        {
          label: "退款金额",
          prop: "refundAmount",
        },
        {
          label: "退款状态",
          prop: "refundStatus",
          type: "input",
          solt: true,
        },
      ],
    },
  ],
};
